module.exports = __webpack_public_path__ + "img/logorobotidea.c151f265.jpg";